export const BDCPromocodes = [
  {
    key: 0,
    productIds: ["68c940d1f0d80c177b482eb8"],
    productName: "Dope Discount **24hrs Vaidity",
    discount: 1000,
    category: "1000/- OFF on Dope for CX",
  },
  {
    key: 1,
    productIds: [
      "63feefa538ced178e34e5b07",
      "63fef7af38ced178e34e5b0a",
      "66123f08886d1a984d1b5015",
    ],
    productName: "X-Factor Bikes Discount [X1, X2, Legend 07] **24hrs Vaidity",
    discount: 1500,
    category: "1500/- OFF on Bikes for X-Factor Range",
  },
  {
    key: 2,
    productIds: [
      "6793903deb4a15d6185be91e",
      "658d75ae05a371a821407b4e",
      "68653121c1e99424312667c9",
      "69e0cbefc1e01dd7ed4f94ea",
    ],
    productName: "Desire Bikes Discount [T-Rex Air, Doodle Pro, Ranger, Viper] **24hrs Vaidity",
    discount: 2500,
    category: "2500/- OFF on Bike for Desire Range",
  },
  {
    key: 3,
    productIds: ["671a36355ca134bab1f04d2f"],
    productName: "ST-X **24hrs Vaidity",
    discount: 3000,
    category: "3000/- OFF on ST-X for CX",
  },
  {
    key: 4,
    productIds: ["679c60a396fb10bcf79b8a12"],
    productName: "Cargo G1 **24hrs Vaidity",
    discount: 6000,
    category: "6000/- OFF on Cargo G1 for CX",
  },
  {
    key: 5,
    productIds: [
      "6360c0c38f175b808a2b3590",
      "6360db9b8f175b808a2b3591",
      "63622317fb55fb5295e5c023",
      "636242d2fb55fb5295e5c024",
      "63636a18b8e31122985325a7",
      "6363b0f9b8e31122985325b1",
      "6363b44db8e31122985325b2",
      "6440e94b6c0366f8be4448d7",
      "64425b84f9d058a511fd99a7",
      "64425f2bf9d058a511fd99a8",
      "66dc1c054015fd82191db243",
      "66e0107a4015fd82191db382",
      "66e82dc14015fd82191db7ba",
      "66e831441fee1a1075c94b2b",
      "66e832364015fd82191db7cc",
      "66eac2071fee1a1075c94c13",
      "66eac28a1fee1a1075c94c1e",
      "66eac3124015fd82191db8cf",
      "66eac3b34015fd82191db8e0",
      "66eac4251fee1a1075c94c2f",
      "66eac4984015fd82191db8f2",
      "66eeb6d61fee1a1075c94e14",
      "66eeb7c14015fd82191dbaca",
      "66eeb8384015fd82191dbadd",
      "66eed0351fee1a1075c94e49",
      "66eed0841fee1a1075c94e53",
      "66eed0f74015fd82191dbafb",
      "66faa6291fee1a1075c95477",
      "670f7e281fee1a1075c95d24",
      "671f8ed4241bfeae721f109f",
      "6805e2c0913bff22209f1a70",
      "6805f68dd20b3d389675893a",
      "66e1475b4015fd82191db406",
      "66e147dc1fee1a1075c9476f",
      "66e171924015fd82191db42a",
      "66e17d781fee1a1075c947a1",
      "66e17f004015fd82191db440",
      "66e183381fee1a1075c947b7",
      "66e183bb4015fd82191db44f",
      "66e1846e4015fd82191db45d",
      "6805ed2ad20b3d38967588fe",
      "6805fb77913bff22209f1aff",
      "697899d50b4be124f34b26d5",
      "697899100b4be124f34b26d4",
      "69789b1f0b4be124f34b26d8",
      "69789a5f0b4be124f34b26d6",
      "69789541d5f2f2ec4ef7f153",
      "697898a20b4be124f34b26d3",
      "697898070b4be124f34b26d2",
      "69709b1d25f0749eba00ed6f",
      "69709ba3b432a8fa86bb61cf",
      "695c943182d69f7ab9c2a19c",
      "695c941682d69f7ab9c2a193",
      "6904c21aa503268784b880a2",
      "6904c1c0555fa2581c810c53",
    ],
    productName: "X-Factor Accessories Promo **24hrs Vaidity",
    discount: 250,
    category: "250/- OFF on Accessories for X-Factor Range",
  },
  {
    key: 6,
    productIds: [
      "6360c0c38f175b808a2b3590",
      "6360db9b8f175b808a2b3591",
      "63622317fb55fb5295e5c023",
      "636242d2fb55fb5295e5c024",
      "63636a18b8e31122985325a7",
      "6363b0f9b8e31122985325b1",
      "6363b44db8e31122985325b2",
      "6440e94b6c0366f8be4448d7",
      "64425b84f9d058a511fd99a7",
      "64425f2bf9d058a511fd99a8",
      "66dc1c054015fd82191db243",
      "66e0107a4015fd82191db382",
      "66e82dc14015fd82191db7ba",
      "66e831441fee1a1075c94b2b",
      "66e832364015fd82191db7cc",
      "66eac2071fee1a1075c94c13",
      "66eac28a1fee1a1075c94c1e",
      "66eac3124015fd82191db8cf",
      "66eac3b34015fd82191db8e0",
      "66eac4251fee1a1075c94c2f",
      "66eac4984015fd82191db8f2",
      "66eeb6d61fee1a1075c94e14",
      "66eeb7c14015fd82191dbaca",
      "66eeb8384015fd82191dbadd",
      "66eed0351fee1a1075c94e49",
      "66eed0841fee1a1075c94e53",
      "66eed0f74015fd82191dbafb",
      "66faa6291fee1a1075c95477",
      "670f7e281fee1a1075c95d24",
      "671f8ed4241bfeae721f109f",
      "6805e2c0913bff22209f1a70",
      "6805f68dd20b3d389675893a",
      "66e1475b4015fd82191db406",
      "66e147dc1fee1a1075c9476f",
      "66e171924015fd82191db42a",
      "66e17d781fee1a1075c947a1",
      "66e17f004015fd82191db440",
      "66e183381fee1a1075c947b7",
      "66e183bb4015fd82191db44f",
      "66e1846e4015fd82191db45d",
      "6805ed2ad20b3d38967588fe",
      "6805fb77913bff22209f1aff",
      "697899d50b4be124f34b26d5",
      "697899100b4be124f34b26d4",
      "69789b1f0b4be124f34b26d8",
      "69789a5f0b4be124f34b26d6",
      "69789541d5f2f2ec4ef7f153",
      "697898a20b4be124f34b26d3",
      "697898070b4be124f34b26d2",
      "69709b1d25f0749eba00ed6f",
      "69709ba3b432a8fa86bb61cf",
      "695c943182d69f7ab9c2a19c",
      "695c941682d69f7ab9c2a193",
      "6904c21aa503268784b880a2",
      "6904c1c0555fa2581c810c53",
    ],
    productName: "Desire Accessories Promo **24hrs Vaidity",
    discount: 500,
    category: "500/- OFF on Accessories for Desire Range",
  },
  {
    key: 7,
    productIds: [
      "6360c0c38f175b808a2b3590",
      "6360db9b8f175b808a2b3591",
      "63622317fb55fb5295e5c023",
      "636242d2fb55fb5295e5c024",
      "63636a18b8e31122985325a7",
      "6363b0f9b8e31122985325b1",
      "6363b44db8e31122985325b2",
      "6440e94b6c0366f8be4448d7",
      "64425b84f9d058a511fd99a7",
      "64425f2bf9d058a511fd99a8",
      "66dc1c054015fd82191db243",
      "66e0107a4015fd82191db382",
      "66e82dc14015fd82191db7ba",
      "66e831441fee1a1075c94b2b",
      "66e832364015fd82191db7cc",
      "66eac2071fee1a1075c94c13",
      "66eac28a1fee1a1075c94c1e",
      "66eac3124015fd82191db8cf",
      "66eac3b34015fd82191db8e0",
      "66eac4251fee1a1075c94c2f",
      "66eac4984015fd82191db8f2",
      "66eeb6d61fee1a1075c94e14",
      "66eeb7c14015fd82191dbaca",
      "66eeb8384015fd82191dbadd",
      "66eed0351fee1a1075c94e49",
      "66eed0841fee1a1075c94e53",
      "66eed0f74015fd82191dbafb",
      "66faa6291fee1a1075c95477",
      "670f7e281fee1a1075c95d24",
      "671f8ed4241bfeae721f109f",
      "6805e2c0913bff22209f1a70",
      "6805f68dd20b3d389675893a",
      "66e1475b4015fd82191db406",
      "66e147dc1fee1a1075c9476f",
      "66e171924015fd82191db42a",
      "66e17d781fee1a1075c947a1",
      "66e17f004015fd82191db440",
      "66e183381fee1a1075c947b7",
      "66e183bb4015fd82191db44f",
      "66e1846e4015fd82191db45d",
      "6805ed2ad20b3d38967588fe",
      "6805fb77913bff22209f1aff",
      "697899d50b4be124f34b26d5",
      "697899100b4be124f34b26d4",
      "69789b1f0b4be124f34b26d8",
      "69789a5f0b4be124f34b26d6",
      "69789541d5f2f2ec4ef7f153",
      "697898a20b4be124f34b26d3",
      "697898070b4be124f34b26d2",
      "69709b1d25f0749eba00ed6f",
      "69709ba3b432a8fa86bb61cf",
      "695c943182d69f7ab9c2a19c",
      "695c941682d69f7ab9c2a193",
      "6904c21aa503268784b880a2",
      "6904c1c0555fa2581c810c53",
    ],
    productName: "Dope Accessories Promo **30 days Vaidity",
    discount: 2000,
    category: "2000/- OFF on Accessories for Dope",
  },
  {
    key: 8,
    productIds: [
      "6360c0c38f175b808a2b3590",
      "6360db9b8f175b808a2b3591",
      "63622317fb55fb5295e5c023",
      "636242d2fb55fb5295e5c024",
      "63636a18b8e31122985325a7",
      "6363b0f9b8e31122985325b1",
      "6363b44db8e31122985325b2",
      "6440e94b6c0366f8be4448d7",
      "64425b84f9d058a511fd99a7",
      "64425f2bf9d058a511fd99a8",
      "66dc1c054015fd82191db243",
      "66e0107a4015fd82191db382",
      "66e82dc14015fd82191db7ba",
      "66e831441fee1a1075c94b2b",
      "66e832364015fd82191db7cc",
      "66eac2071fee1a1075c94c13",
      "66eac28a1fee1a1075c94c1e",
      "66eac3124015fd82191db8cf",
      "66eac3b34015fd82191db8e0",
      "66eac4251fee1a1075c94c2f",
      "66eac4984015fd82191db8f2",
      "66eeb6d61fee1a1075c94e14",
      "66eeb7c14015fd82191dbaca",
      "66eeb8384015fd82191dbadd",
      "66eed0351fee1a1075c94e49",
      "66eed0841fee1a1075c94e53",
      "66eed0f74015fd82191dbafb",
      "66faa6291fee1a1075c95477",
      "670f7e281fee1a1075c95d24",
      "671f8ed4241bfeae721f109f",
      "6805e2c0913bff22209f1a70",
      "6805f68dd20b3d389675893a",
      "66e1475b4015fd82191db406",
      "66e147dc1fee1a1075c9476f",
      "66e171924015fd82191db42a",
      "66e17d781fee1a1075c947a1",
      "66e17f004015fd82191db440",
      "66e183381fee1a1075c947b7",
      "66e183bb4015fd82191db44f",
      "66e1846e4015fd82191db45d",
      "6805ed2ad20b3d38967588fe",
      "6805fb77913bff22209f1aff",
      "697899d50b4be124f34b26d5",
      "697899100b4be124f34b26d4",
      "69789b1f0b4be124f34b26d8",
      "69789a5f0b4be124f34b26d6",
      "69789541d5f2f2ec4ef7f153",
      "697898a20b4be124f34b26d3",
      "697898070b4be124f34b26d2",
      "69709b1d25f0749eba00ed6f",
      "69709ba3b432a8fa86bb61cf",
      "695c943182d69f7ab9c2a19c",
      "695c941682d69f7ab9c2a193",
      "6904c21aa503268784b880a2",
      "6904c1c0555fa2581c810c53",
    ],
    productName: "X-Factor Accessories Promo **30 days Vaidity",
    discount: 3000,
    category: "3000/- OFF on Accessories for X-Factor Range",
  },
  {
    key: 9,
    productIds: [
      "6360c0c38f175b808a2b3590",
      "6360db9b8f175b808a2b3591",
      "63622317fb55fb5295e5c023",
      "636242d2fb55fb5295e5c024",
      "63636a18b8e31122985325a7",
      "6363b0f9b8e31122985325b1",
      "6363b44db8e31122985325b2",
      "6440e94b6c0366f8be4448d7",
      "64425b84f9d058a511fd99a7",
      "64425f2bf9d058a511fd99a8",
      "66dc1c054015fd82191db243",
      "66e0107a4015fd82191db382",
      "66e82dc14015fd82191db7ba",
      "66e831441fee1a1075c94b2b",
      "66e832364015fd82191db7cc",
      "66eac2071fee1a1075c94c13",
      "66eac28a1fee1a1075c94c1e",
      "66eac3124015fd82191db8cf",
      "66eac3b34015fd82191db8e0",
      "66eac4251fee1a1075c94c2f",
      "66eac4984015fd82191db8f2",
      "66eeb6d61fee1a1075c94e14",
      "66eeb7c14015fd82191dbaca",
      "66eeb8384015fd82191dbadd",
      "66eed0351fee1a1075c94e49",
      "66eed0841fee1a1075c94e53",
      "66eed0f74015fd82191dbafb",
      "66faa6291fee1a1075c95477",
      "670f7e281fee1a1075c95d24",
      "671f8ed4241bfeae721f109f",
      "6805e2c0913bff22209f1a70",
      "6805f68dd20b3d389675893a",
      "66e1475b4015fd82191db406",
      "66e147dc1fee1a1075c9476f",
      "66e171924015fd82191db42a",
      "66e17d781fee1a1075c947a1",
      "66e17f004015fd82191db440",
      "66e183381fee1a1075c947b7",
      "66e183bb4015fd82191db44f",
      "66e1846e4015fd82191db45d",
      "6805ed2ad20b3d38967588fe",
      "6805fb77913bff22209f1aff",
      "697899d50b4be124f34b26d5",
      "697899100b4be124f34b26d4",
      "69789b1f0b4be124f34b26d8",
      "69789a5f0b4be124f34b26d6",
      "69789541d5f2f2ec4ef7f153",
      "697898a20b4be124f34b26d3",
      "697898070b4be124f34b26d2",
      "69709b1d25f0749eba00ed6f",
      "69709ba3b432a8fa86bb61cf",
      "695c943182d69f7ab9c2a19c",
      "695c941682d69f7ab9c2a193",
      "6904c21aa503268784b880a2",
      "6904c1c0555fa2581c810c53",
    ],
    productName: "Desire Accessories Promo **30 days Vaidity",
    discount: 5000,
    category: "5000/- OFF on Accessories for Desire Range",
  },
  // {
  //   key: 3,
  //   productIds: ["66123f08886d1a984d1b5015"],
  //   productName: "Legend 07 MSD Edition",
  //   discount: 2000,
  //   category: "2000/- OFF on Legend 07 for CX",
  // },
  // {
  //   key: 4,
  //   productIds: ["658d75ae05a371a821407b4e"],
  //   productName: "T-Rex Air",
  //   discount: 3000,
  //   category: "3000/- OFF on T-Rex Air for CX",
  // },
  // {
  //   key: 5,
  //   productIds: ["6793903deb4a15d6185be91e"],
  //   productName: "Doodle Pro",
  //   discount: 4000,
  //   category: "4000/- OFF on Doodle Pro for CX",
  // },
  // {
  //   key: 6,
  //   productIds: ["68653121c1e99424312667c9"],
  //   productName: "Ranger",
  //   discount: 4000,
  //   category: "4000/- OFF on Ranger for CX",
  // },
  // {
  //   key: 7,
  //   productIds: ["69e0cbefc1e01dd7ed4f94ea"],
  //   productName: "Viper",
  //   discount: 4000,
  //   category: "4000/- OFF on Ranger for CX",
  // },
  // {
  //   key: 2,
  //   productIds: ["63fefa0938ced178e34e5b0b"],
  //   productName: "X3",
  //   discount: 1000,
  //   category: "1000/- OFF on X3 for CX",
  // },
  // {
  //   key: 2,
  //   productIds: ["671a36355ca134bab1f04d2f"],
  //   productName: "ST-X",
  //   discount: 1000,
  //   category: "1000/- OFF on ST-X for CX",
  // },
  // {
  //   key: 5,
  //   productIds: ["6544a7d5897107b23599ba8f"],
  //   productName: "T-Rex+",
  //   discount: 1500,
  //   category: "1500/- OFF on T-Rex+ for CX",
  // },
  // {
  //   key: 6,
  //   productIds: ["66f2be4a4015fd82191dbbe4"],
  //   productName: "T-Rex Pro",
  //   category: "1500/- OFF on T-Rex Pro for CX",

  //   discount: 1500,
  // },

  // {
  //   key: 8,
  //   productIds: ["62df88017cad1d7a52899f4b"],
  //   productName: "Lil E",
  //   discount: 1000,
  //   category: "1000/- OFF on Lil E for CX",
  // },
];
